var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.docs
    ? _c(
        "w-modal",
        { attrs: { value: "" } },
        [
          _c("app-aws-files-info-modal", {
            attrs: { files: _vm.docs },
            on: {
              close: function ($event) {
                return _vm.closeLast()
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }